export const formatDate = (
  timestamp: number | string | Date | null | undefined,
  format: string = '{y}/{m}/{d}',
): string => {
  if (!timestamp) return ''
  const date = new Date(timestamp)
  if (isNaN(date.getTime())) return ''

  const y = String(date.getFullYear())
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const d = String(date.getDate()).padStart(2, '0')
  const h = String(date.getHours()).padStart(2, '0')
  const i = String(date.getMinutes()).padStart(2, '0')
  const s = String(date.getSeconds()).padStart(2, '0')

  return String(format).replace(/\{([yYmMdDhHiIsS])\}/g, (_: string, k: string) => {
    switch (k.toLowerCase()) {
      case 'y':
        return y
      case 'm':
        return m
      case 'd':
        return d
      case 'h':
        return h
      case 'i':
        return i
      case 's':
        return s
      default:
        return ''
    }
  })
}
